import { render, staticRenderFns } from "./LessonEditor.vue?vue&type=template&id=4e47d190&scoped=true"
import script from "./LessonEditor.vue?vue&type=script&lang=js"
export * from "./LessonEditor.vue?vue&type=script&lang=js"
import style0 from "./LessonEditor.vue?vue&type=style&index=0&id=4e47d190&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e47d190",
  null
  
)

export default component.exports